import charactersAndNumbersSeparator from "../../../utils/charactersAndNumbersSeparator";

type Props = {
  shortName: string;
};
const ShortName = ({ shortName }: Props) => {
  const { word, digits } = charactersAndNumbersSeparator(shortName);

  return (
    <>
      <span className="fs-md">{word}</span>
      <span className="text-primary fw-bold fs-md">{digits}</span>
    </>
  );
};

export default ShortName;
